<mat-toolbar class="mat-toolbar-azul">
  <img [src]="logoVisorWeb" width="250" height="auto" fxHide.xs>
  <img [src]="logoVisorWeb" width="200" height="90%" fxShow.xs fxHide.sm fxHide.lg fxHide.md
    fxHide.xl>
  <span class="spacer-banner"></span>
  <button mat-icon-button (click)="closeDialogModificarPartidaPresupuesto()" class="menu-button">
    <mat-icon matSuffix>close</mat-icon>
  </button>
</mat-toolbar>
<mat-card class="card-grey">
  <mat-card-title class="card-title">Modificar Partida ({{reference}})</mat-card-title>
  <mat-card-content>
    <form [formGroup]="updateLineItemBudgetForm" fxLayoutGap="10px" style="padding-top: 10px;">
      <div class="row-flex" fxLayoutGap="20px" fxLayoutGap.xs="10px" fxLayout.xs="column">
        <mat-form-field appearance="outline" [ngClass]="classFlag ? 'input-width-275' : 'input-width-small'"
          floatLabel="always">
          <mat-label>Partida N°:</mat-label>
          <mat-select [(ngModel)]="activeLineItemsBudget" [formControl]="selectedLineItemBudget"
            (selectionChange)="onChangeSelect()">
            <mat-option *ngFor="let item of listSelectLineItemsBudget" [value]="item.id">{{item.value}}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field [ngClass]="classFlag ? 'input-width-275' : 'input-width-small'" appearance="outline"
          floatLabel="always">
          <mat-label>Referencia </mat-label>
          <input matInput formControlName="reference">
        </mat-form-field>
      </div>
      <div class="row-flex" fxLayout.xs="column">
        <div class="col">
          <mat-form-field appearance="outline" class="full-width" floatLabel="always">
            <mat-label>Descripción </mat-label>
            <textarea matInput formControlName="description" name="description" cdkTextareaAutosize
              #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1" cdkAutosizeMaxRows="5"></textarea>
          </mat-form-field>
        </div>
      </div>
      <div class="row-flex" fxLayoutGap="20px" fxLayoutGap.xs="10px" fxLayout.xs="column">
        <mat-form-field [ngClass]="classFlag ? 'input-width-275' : 'input-width-small'" appearance="outline"
          floatLabel="always">
          <mat-label> Cantidad </mat-label>
          <input matInput formControlName="quantity" (keyup)="calculateAmount()" (blur)="onSubmit()">
          <mat-error *ngIf="updateLineItemBudgetForm.controls['quantity'].hasError('required')">Campo es
            requerido.</mat-error>
          <mat-error *ngIf="updateLineItemBudgetForm.controls['quantity'].hasError('pattern')">Solo números.</mat-error>
        </mat-form-field>
        <mat-form-field [ngClass]="classFlag ? 'input-width-275' : 'input-width-small'" appearance="outline"
          floatLabel="always">
          <mat-label> Precio </mat-label>
          <input matInput value="{{ price | number:'1.2-2':'es' }}" [disabled]="true">
        </mat-form-field>
        </div>
        <div class="row-flex" fxLayoutGap="20px" fxLayoutGap.xs="10px" fxLayout.xs="column"
          style="padding-left: 2px; padding-right: 8px;">
            <mat-form-field appearance="outline" [ngClass]="classFlag ? 'input-width-275' : 'input-width-350'"
              floatLabel="always">
              <mat-label>Total Partida</mat-label>
              <input matInput value="{{ total | number:'1.2-2':'es' }}" [disabled]="true">
            </mat-form-field>
        </div>
      </form>
      </mat-card-content>
      <mat-card-actions>
        <div class="mat-card-cvr" fxLayoutGap="5px">
          <button mat-stroked-button type="button" matTooltip="Primera Página" matTooltipPosition="above"
            [disabled]="disablePrevious" (click)="onFirstClick()">
            <mat-icon>first_page</mat-icon>
          </button>
          <button mat-stroked-button type="button" matTooltip="Página Anterior" matTooltipPosition="above"
            [disabled]="disablePrevious" (click)="onPreviousClick()">
            <mat-icon>navigate_before</mat-icon>
          </button>
          <button mat-stroked-button type="button" matTooltip="Página Siguiente" matTooltipPosition="above"
            [disabled]="disableNext" (click)="onNextClick()">
            <mat-icon>navigate_next</mat-icon>
          </button>
          <button mat-stroked-button type="button" matTooltip="Última pagina" matTooltipPosition="above"
            [disabled]="disableNext" (click)="onLastClick()">
            <mat-icon>last_page</mat-icon>
      </button>
      </div>
  </mat-card-actions>
</mat-card>